import React from "react";
import { Typography } from "@/design-system/Atoms";

type TableColumn<T> = {
  label: string;
  accessor: keyof T;
};

type TableGridProps<T> = {
  columns: TableColumn<T>[];
  data: T[];
  onRowClick?: (row: T) => void;
  renderActions?: (row: T) => React.ReactNode;
};

export const TableGrid = <T extends Record<string, any>>({
  columns,
  data,
  onRowClick,
  renderActions,
}: TableGridProps<T>) => {
  return (
    <div className="overflow-x-auto touch-auto bg-white rounded-lg p-5">
      <div className="max-h-[25rem] overflow-y-auto">
        <table className="w-full text-[1rem] text-left text-[#3B4151] border-collapse mb-4">
          <thead className="bg-[#fafafa] text-black">
            <tr>
              <th className="px-2 py-2 font-bold">
                <Typography variant="sectionDescriptionExtraSmall" as="h4">
                  #
                </Typography>
              </th>
              {columns.map((col) => (
                <th key={String(col.accessor)} className="px-2 py-2 font-bold">
                  <Typography variant="sectionDescriptionExtraSmall" as="h4">
                    {col.label}
                  </Typography>
                </th>
              ))}
              {renderActions && (
                <th className="px-2 py-2 font-bold">
                  <Typography variant="sectionDescriptionExtraSmall" as="h4">
                    Actions
                  </Typography>
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr
                key={index} 
                onClick={onRowClick ? () => onRowClick(row) : undefined}
                className={
                  onRowClick
                    ? "cursor-pointer hover:bg-gray-100 transition-colors"
                    : ""
                }
              >
                <th className="px-2 py-2 font-bold">{index + 1}</th>
                {columns.map((col) => (
                  <td key={String(col.accessor)} className="px-2 py-2">
                    {row[col.accessor] as React.ReactNode}
                  </td>
                ))}
                {renderActions && (
                  <td className="px-2 py-2">{renderActions(row)}</td>
                )}
              </tr>
            ))}
            {data.length === 0 && (
              <tr>
                <td
                  colSpan={columns.length + 1}
                  className="text-center py-4 text-gray-400"
                >
                  No results found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableGrid; 
